import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import { ClientsArr1, testimonialData, zomatoFeatures, videoTestimonial, zomatoFAQ, swiggyFAQ, swiggyFeatures , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopPlural = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    const Features = [
        {
            id: 1,
            image: "/assets/PluralPayments/payment.svg",
            title: "Multiple Payment Methods",
            desc: "Enhance customer satisfaction by offering a diverse range of payment options. Providing customers with various payment methods such as credit/debit cards, mobile payments, and online wallet services can improve their overall shopping experience and make transactions more convenient for them.",
            bgColor: "#8ae4f626",
            imageHeight: "50rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            imageWidth: "40rem",
            tagColor: "#C9F6FF",
            points: [
                "Supports credit/debit cards, UPI, mobile wallets, and more.",
                "Allows easy integration with leading payment gateways.",
                "Enables fast, secure, and contactless payments at checkout.",
            ]
        },
        {
            id: 2,
            image: "/assets/PluralPayments/transaction.svg",
            title: "Real Time Transaction Processing and Reporting",
            desc: "Stay on top of your transactions with real-time processing and comprehensive reporting means that you can effectively manage and track your financial transactions as they occur, ensuring that you have up-to-date information on your financial activities. Realtime processing allows for immediate recording and verification of transactions, while comprehensive reporting provides detailed insights and analysis of your financial data. This approach can help you make informed decisions and maintain a clear understanding of your financial position.",
            bgColor: "#F2FDEB",
            imageHeight: "50rem",
            mobImageHeight: "16rem",
            btnText: "Request a callback",
            tagColor: "#d4f4bf",
            points: [
                "Transactions are instantly processed and reflected across all platforms.",
                "Access up-to-date reports on sales, refunds, and customer activity.",
                "Automatic data reconciliation reduces errors and saves time.",

            ]
               
        },
        {
            id: 3,
            image: "/assets/PluralPayments/refund.svg",
            title: "Seamless Refund and Dispute Management",
            desc: "Handle refunds and disputes with confidence, keeping your customers happy, satisfied, and loyal to your brand. By effectively managing refunds and disputes, you can maintain positive relationships with your customers and solidify their trust in your products or services.",
            bgColor: "#FCF7FF",
            imageHeight: "44rem",
            mobImageHeight: "22rem",
            btnText: "Talk to an expert",
            tagColor: "#e6ccf6",
            points: [
                "Process refunds directly from the POS system with ease.",
                "Track the status of refunds and disputes in real time.",
                "Receive alerts and notifications to resolve disputes promptly.",
            ]
        },
        {
            id: 4,
            image: "/assets/PluralPayments/offline.svg",
            title: "Offline Payment Processing",
            desc: "Keep your business operational even during network outages with offline payment processing. With offline payment processing, you can continue to accept payments from your customers even when there is a disruption in your network connectivity. This ensures that your business can still conduct transactions seamlessly, providing a reliable and uninterrupted service to your customers.",
            bgColor: "#8ae4f626",
            imageHeight: "40rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            tagColor: "#C9F6FF",
            points: [
               " Securely stores transactions and processes them once connectivity is restored.",
                "Supports all payment methods in offline mode.",
               " Minimizes downtime, ensuring uninterrupted sales and service.",
            ]
        },
    ]

    const FAQ = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is Plural Payment Gateway and how does it integrate with QueueBuster POS?
                </span>
            ),
            des: "Plural Payment Gateway is a robust, multichannel payment processing solution that supports various payment methods, including credit and debit cards, UPI, mobile wallets, and net banking. When integrated with QueueBuster POS, it allows businesses to accept payments seamlessly from multiple channels within the same interface. The integration ensures that transactions are processed in real-time, offering customers a smooth and secure payment experience while giving businesses access to detailed reports and analytics directly through the POS system.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What types of payments can I accept through the Plural Payment Gateway integrated with QueueBuster POS?
                </span>
            ),
            des:[
                <>
                 <>With the Plural Payment Gateway integrated into QueueBuster POS, you can accept a wide range of payment types, including: <br /></>
                    <>
                        <> <b>Credit and Debit Cards:</b>  All major cards such as Visa, MasterCard, American Express, and more <br /></>
                        <><b>UPI (Unified Payments Interface):</b>  A popular and fast-growing payment method in India. <br /></>
                        <><b>Mobile Wallets: </b>Including Paytm, Google Pay, PhonePe, and other widely used wallets.<br /></>
                        <> <b>Net Banking:</b>Direct transfers from bank accounts.</>
                    </>
                </>
            ],
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does real-time transaction processing work with Plural Payment Gateway and QueueBuster POS?
                </span>
            ),
            des: "Realtime transaction processing with Plural Payment Gateway means that as soon as a customer initiates a payment, the transaction is processed immediately, and the result (success or failure) is reflected instantly in QueueBuster POS. This rapid processing is crucial for maintaining a seamless checkout experience, minimizing delays, and ensuring that your inventory, sales reports, and customer data are always up-to-date. The real-time nature also helps in quickly identifying and resolving any issues, such as payment failures or network interruptions.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I manage refunds and disputes directly through QueueBuster POS when using the Plural Payment Gateway?
                </span>
            ),
            des: "Yes, the integration of Plural Payment Gateway with QueueBuster POS allows you to manage refunds and disputes directly from the POS interface. You can initiate refunds for customers who return items or have issues with their purchase, and the system will track the refund status in real-time. Additionally, in case of payment disputes or chargebacks, the integrated system provides tools to manage and resolve these disputes efficiently, ensuring transparency and customer satisfaction while keeping your records accurate and up-to-date.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What happens if my internet connection goes down? Can I still process payments with QueueBuster POS and Plural Payment Gateway?
                </span>
            ),
            des: "Yes, you can still process payments even if your internet connection goes down, thanks to the offline payment processing feature of QueueBuster POS integrated with Plural Payment Gateway. When operating offline, the system securely stores transaction data locally on your device. Once the connection is restored, the stored transactions are automatically processed and synced with the central system. This ensures that your business operations continue smoothly without any interruptions, minimizing potential revenue loss due to connectivity issues.",
            id: 5,
            activeIndex: 0,
        },

        {
            para: (
                <span style={{ width: "90%" }}>
                   How does the integration improve reporting and analytics in QueueBuster POS?
                </span>
            ),
            des: "The integration of Plural Payment Gateway with QueueBuster POS enhances your reporting and analytics capabilities by providing real-time data on all transactions processed through the system. You can access detailed reports that break down sales by payment method, track refund statuses, monitor customer purchasing behaviors, and analyze peak transaction times. These insights allow you to make informed business decisions, optimize your payment processes, and improve customer satisfaction. Additionally, automated reconciliation features help reduce manual errors, making your financial reporting more accurate and efficient.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     Is it secure to use Plural Payment Gateway with QueueBuster POS?                   
                </span>
            ),
            des: "Absolutely. Security is a top priority in the integration of Plural Payment Gateway with QueueBuster POS. The payment gateway complies with the latest security standards, ensuring that all transactions are encrypted and secure. Additionally, the system is equipped with fraud detection tools that monitor transactions for suspicious activity, helping to prevent unauthorized transactions and protecting your business and your customers’ sensitive data.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                How easy is it to set up and start using Plural Payment Gateway with QueueBuster POS?
                </span>
            ),
            des: "Setting up a Plural Payment Gateway with QueueBuster POS is straightforward. The integration is designed to be user-friendly, with a guided setup process that typically requires minimal technical expertise. Once the payment gateway is configured, you can immediately start accepting payments through various channels. QueueBuster POS also offers customer support to assist with the setup and any technical issues, ensuring that your business can start benefiting from the integration quickly and without hassle.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I customize the payment options available to my customers through QueueBuster POS?
                </span>
            ),
            des: "Yes, you have full control over the payment options you offer to your customers when using the Plural Payment Gateway integrated with QueueBuster POS. You can enable or disable specific payment methods based on your business needs or customer preferences. For example, you might choose to prioritize digital wallets or UPI payments in regions where they are more popular, while still accepting credit and debit cards for other transactions. This flexibility allows you to tailor the payment experience to best suit your customer base.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does Plural Payment Gateway integration affect my transaction fees with QueueBuster POS?

                </span>
            ),
            des: "Transaction fees are determined by the payment methods you enable and the terms set by your payment gateway provider. When you integrate Plural Payment Gateway with QueueBuster POS, the system is designed to optimize these fees by offering you the ability to choose the most cost-effective payment methods. Additionally, the real-time processing and automated reconciliation features can help reduce hidden costs associated with manual processing errors or delayed transactions. To get precise details on fees, it’s recommended to consult with the payment gateway provider during setup.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo} style={{ width: "12rem" }}><Image src="/assets/PluralPayments/plural.svg" alt="GSP" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Plural Integration with</span><br />
                        <span className={styles.black_text}>with</span><span className={styles.blue_text}> QueueBuster POS</span>
                    </h1>
                    <p className={styles.page_desc}> Unlock the full potential of your business with Plural Payments seamlessly integrated into QueueBuster POS. This powerful combination allows you to offer a variety of payment methods, ensures real-time transaction processing, and simplifies refund and dispute management—all while keeping your operations running smoothly, even offline.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img} style={{ height: "38rem" }}><Image src="/assets/PluralPayments/plural-img.svg" alt="geodea" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
            <div className={styles.section_heading}><h3> Key Features of Plural Payments with QueueBuster POS</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>

                <HardwareFeatures features={Features} setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={FAQ} heading={"FAQs for Plural Payment Gateway Integrated with QueueBuster POS"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopPlural
 